/* BTP Cart — bridge custom BTP cart events to Horizon's cart drawer */
(function () {
  'use strict';

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: { source: 'btp-cart' },
        },
      })
    );
  }

  function bridgeBtpCartEvent() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(dispatchCartUpdate)
      .catch(function () {});
  }

  document.addEventListener('cart:item-added', bridgeBtpCartEvent);
}());
